/*
 * @description:
 * @author: Jason Wong
 * @since: 2024-07-11 17:01:03
 */
import { createLocalStorage, createSessionStorage } from "./";
import { Memory } from "./memory";
import {
  TOKEN_KEY,
  USER_INFO_KEY,
  ROLES_KEY,
  LOCK_INFO_KEY,
  PROJ_CFG_KEY,
  APP_LOCAL_CACHE_KEY,
  APP_SESSION_CACHE_KEY,
  MULTIPLE_TABS_KEY,
  DB_DICT_DATA_KEY,
  TENANT_ID,
  LOGIN_INFO_KEY,
  OAUTH2_THIRD_LOGIN_TENANT_ID,
} from "../../enums/cacheEnum";
import { DEFAULT_CACHE_TIME } from "../../configs/encryptionConfig";
import { pick, omit } from "lodash";

const ls = createLocalStorage();
const ss = createSessionStorage();

const localMemory = new Memory(DEFAULT_CACHE_TIME);
const sessionMemory = new Memory(DEFAULT_CACHE_TIME);

function initPersistentMemory() {
  console.log("#initPersistentMemory");
  const localCache = ls.get(APP_LOCAL_CACHE_KEY);
  const sessionCache = ss.get(APP_SESSION_CACHE_KEY);
  localCache && localMemory.resetCache(localCache);
  sessionCache && sessionMemory.resetCache(sessionCache);
}

export class Persistent {
  /**
   *
   * @param {string} key
   * @returns
   */
  static getLocal(key) {
    const globalCache = ls.get(APP_LOCAL_CACHE_KEY);
    if (globalCache) {
      localMemory.setCache(globalCache);
    }
    return (localMemory.get(key) || {}).value;
  }

  static setLocal(key, value, immediate = false) {
    localMemory.set(key, value);
    immediate && ls.set(APP_LOCAL_CACHE_KEY, localMemory.getCache);
  }

  static removeLocal(key, immediate = false) {
    localMemory.remove(key);
    immediate && ls.set(APP_LOCAL_CACHE_KEY, localMemory.getCache);
  }

  static clearLocal(immediate = false) {
    localMemory.clear();
    immediate && ls.clear();
  }

  static getSession(key) {
    return (sessionMemory.get(key) || {}).value;
  }

  static setSession(key, value, immediate = false) {
    sessionMemory.set(key, value);
    immediate && ss.set(APP_SESSION_CACHE_KEY, sessionMemory.getCache);
  }

  static removeSession(key, immediate = false) {
    sessionMemory.remove(key);
    immediate && ss.set(APP_SESSION_CACHE_KEY, sessionMemory.getCache);
  }
  static clearSession(immediate = false) {
    sessionMemory.clear();
    immediate && ss.clear();
  }

  static clearAll(immediate = false) {
    localMemory.clear();
    if (!!immediate) {
      ls.clear();
      ss.clear();
    }
  }
}

window.addEventListener("beforeunload", function () {
  ls.set(APP_LOCAL_CACHE_KEY, {
    ...omit(localMemory.getCache, LOCK_INFO_KEY),
    ...pick(ls.get(APP_LOCAL_CACHE_KEY), [TOKEN_KEY, USER_INFO_KEY, TENANT_ID, LOCK_INFO_KEY]),
  });
  ss.set(APP_SESSION_CACHE_KEY, {
    ...omit(sessionMemory.getCache, LOCK_INFO_KEY),
    ...pick(ss.get(APP_SESSION_CACHE_KEY), [TOKEN_KEY, USER_INFO_KEY, TENANT_ID, LOCK_INFO_KEY]),
  });
});

function storageChange(e) {
  const { key, newValue, oldValue } = e;

  if (!key) {
    Persistent.clearAll();
    return;
  }

  if (!!newValue && !!oldValue) {
    if (APP_LOCAL_CACHE_KEY === key) {
      Persistent.clearLocal();
    }
    if (APP_SESSION_CACHE_KEY === key) {
      Persistent.clearSession();
    }
  }
}

window.addEventListener("storage", storageChange);
initPersistentMemory();
